import { ReactNode } from "react";
import Controls from "./Controls";
import Progress, { ProgressIcon } from "./Progress";
import RoomHeader from "./RoomHeader";
import { useTranslation } from "./Localization";
import { useTourMode } from "./TourMode";

type Props = { instruction?: string; taskKey?: string; step: number; backTo: string; nextTo: string; gesture?: "none" | "up" | "down"; progressIcon?: ProgressIcon; children: ReactNode };

export default function SalonActivityLayout({ instruction = "", taskKey, step, backTo, nextTo, gesture = "none", progressIcon = "center", children }: Props) {
  const { room } = useTranslation();
  const { interactive } = useTourMode();
  return <main className="screen activity salon-activity">
    <RoomHeader roomId="salon" />
    <p className="instruction">{(taskKey && room("salon")?.tasks[taskKey]) || instruction}</p>
    <div className="salon-task-content">{children}</div>
    <Progress step={step} total={4} gesture={gesture} icon={progressIcon} showDots={interactive} />
    <Controls backTo={backTo} nextTo={nextTo} />
  </main>;
}
